import React from 'react';
import {Link} from 'react-router-dom';
import AurProfilePicture from '../../../common/aur-profile-picture/AurProfilePicture';

const ProfilePicture: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Profile Picture</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurProfilePicture
            bgColor={true}
            displayText="GH"
            borderRadius={2.84}
            iconSize={91}
            textSize="Medium"
            iconType="User"
          />
        </div>
      </div>
    </>
  );
};

export default ProfilePicture;
